<template>
    <Modal :title="$t('labels.moving')" ref="modal" size="full">
        <div class="modal-body">
            <div class="row">
                <div class="col-lg-2">
                    <FormGroup :label="$t('labels.type')">
                        <Select
                            :model-value="filters.declarationTypes?.[0]?.key"
                            :selected-value="filters.declarationTypes?.[0]?.name"
                            :options="declarationTypes"
                            :canBeEmpty="true"
                            @update:model-value="declarationType => filters.declarationTypes = [declarationType]"
                        />
                    </FormGroup>
                </div>
                <div class="col-lg-2">
                    <FormGroup :label="$t('labels.arrival_declaration_status')">
                        <Select
                            :model-value="filters.arrivalDeclarationStatuses?.[0]?.uuid"
                            :selected-value="filters.arrivalDeclarationStatuses?.[0]?.name"
                            :options="arrivalDeclarationStatuses"
                            :canBeEmpty="true"
                            :disabled="filters.declarationTypes?.[0]?.key === 'exit_declaration'"
                            @update:model-value="arrivalDeclarationStatus => filters.arrivalDeclarationStatuses = [arrivalDeclarationStatus]"
                        />
                    </FormGroup>
                </div>
                <div class="col-lg-2">
                    <FormGroup :label="$t('labels.exit_declaration_status')">
                        <Select
                            :model-value="filters.exitDeclarationStatuses?.[0]?.uuid"
                            :selected-value="filters.exitDeclarationStatuses?.[0]?.name"
                            :options="exitDeclarationStatuses"
                            :canBeEmpty="true"
                            :disabled="filters.declarationTypes?.[0]?.key === 'arrival_declaration'"
                            @update:model-value="exitDeclarationStatus => filters.exitDeclarationStatuses = [exitDeclarationStatus]"
                        />
                    </FormGroup>
                </div>
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.from_date')">
                        <DatePicker v-model="filters.date.from"/>
                    </FormGroup>
                </div>
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.to_date')">
                        <DatePicker v-model="filters.date.to"/>
                    </FormGroup>
                </div>
            </div>
            <FetchTable
                :handle="tableHandle"
                url="/management/warehouses/products/moves"
                :columns="table.columns"
                v-model:orders="table.orders"
            >
                <template #td-declarationType="{row}">
                    <router-link :to="row.type === 'arrival-declaration'
                        ? { name: 'EditArrivalDeclarationPage', params: { arrivalDeclarationUuid: row.uuid } }
                        : { name: 'EditExitDeclarationPage', params: { exitDeclarationUuid: row.uuid } }">
                        {{ row.type === 'arrival-declaration' ? $t('labels.arrival_declaration') + ' №' + row.id : $t('labels.exit_declaration') + ' №' + row.id }}
                    </router-link>
                </template>
                <template #td-status="{row}">
                    <span class="badge" :style="{
                        background: row.status.color,
                        color : 'white'
                    }">{{ row.status.name }}</span>
                </template>
                <template #td-amount="{row}">
                    {{ Amount.factory(row.amount).toMeasurementString(product.measurement) }}
                </template>
                <template #td-datetime="{row}">
                    {{ DateFormatter.formatDateTime(row.datetime) }}
                </template>
            </FetchTable>
        </div>
    </Modal>
</template>
<script>
import Modal from "../../../../../components/new/modal/AppModal.vue";
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import Select from "../../../../../components/new/form/select/AppSelect.vue";
import FetchTable from "../../../../../components/new/table/FetchTable.vue";
import { createTableHandle } from "../../../../../components/new/table/tableHandle";
import DatePicker from "../../../../../components/new/form/datePiker/DatePicker.vue";
import Amount from "../../../../../services/Amount.ts";
import {httpClient} from "../../../../../services/HttpClient.ts";
import DateFormatter from "../../../../../services/DateFormatter.ts"
export default {
    name: "MovingModal",
    components: {
        Modal, FormGroup, Select, FetchTable, DatePicker
    },
    props: {
        product: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            DateFormatter,
            Amount: Amount,
            table: {
                orders: [{
                    column: 'datetime',
                    dir: 'desc'
                }],
                columns: [
                    {key: 'declarationType', name: this.$t('labels.declaration_type'), width: '200px', type: 'string', order: false},
                    {key: 'status', name: this.$t('labels.status'), width: '200px', type: 'string', order: false},
                    {key: 'amount', name: this.$t('labels.amount'), width: '200px', type: 'number', order: false},
                    {key: 'datetime', name: this.$t('table.titles.date'), width: '200px', type: 'number', order: true},
                ]
            },
            filters: {
                declarationTypes: [],
                exitDeclarationStatuses: [],
                arrivalDeclarationStatuses: [],
                date: {
                    from: null,
                    to: null
                }
            },
            exitDeclarationStatuses: [],
            arrivalDeclarationStatuses: [],
            declarationTypes: [
                {
                    key: 'exit_declaration',
                    name: this.$t('labels.exit_declaration')
                },
                {
                    key: 'arrival_declaration',
                    name: this.$t('labels.arrival_declaration')
                }
            ],
            warehouseUuid: null
        }
    },
    watch: {
        filters: {
            handler: function () {
                this.refreshTable()
            },
            deep: true
        }
    },
    methods: {
        show(warehouseUuid) {
            this.warehouseUuid = warehouseUuid
            this.fetchMoving()
            this.$refs.modal.show()
        },
        refreshTable() {
            this.tableHandle.page = 1
            this.tableHandle.fetchRows({
                warehouse_uuids: [this.warehouseUuid],
                product_uuids: [this.product.uuid],
                declaration_types: [this.filters.declarationTypes?.[0]?.key],
                exit_declaration_status_uuids: [this.filters.exitDeclarationStatuses?.[0]?.uuid],
                arrival_declaration_status_uuids: [this.filters.arrivalDeclarationStatuses?.[0]?.uuid],
                from_date: this.filters.date.from,
                to_date: this.filters.date.to
            })
        },
        async fetchExitDeclarationStatuses() {
            await httpClient.get('/management/exit-declaration-statuses').then((response) => {
                this.exitDeclarationStatuses = response.data.data
            })
        },
        async fetchArrivalDeclarationStatuses() {
            await httpClient.get('/management/arrival-declaration-statuses').then((response) => {
                this.arrivalDeclarationStatuses = response.data.data
            })
        },
        getStatus(row) {
            if (row.type === 'arrival-declaration') {
                return this.arrivalDeclarationStatuses.find(status => status.uuid === row.status_uuid)
            } else {
                return this.exitDeclarationStatuses.find(status => status.uuid === row.status_uuid)
            }
        },
        fetchMoving() {
            if (!this.warehouseUuid) {
                return
            }

            this.refreshTable()
        }
    },
    mounted() {
        this.fetchExitDeclarationStatuses()
        this.fetchArrivalDeclarationStatuses()
    }
}
</script>